import { render, staticRenderFns } from "./MyPerformance.vue?vue&type=template&id=d5fbb948&"
import script from "./MyPerformance.vue?vue&type=script&lang=js&"
export * from "./MyPerformance.vue?vue&type=script&lang=js&"
import style0 from "./MyPerformance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports